export default __webpack_public_path__ + "static/media/Active-hcp-icon-new.8680ede8.svg";